import React from 'react';
import { connect } from 'react-redux';

import { Panel, PanelTop, PanelBody } from 'components/Panel';
import PlayerLink from 'components/PlayerLink';

const NewsX = ({ news }) => (
    <Panel id="home-page-news">
        <PanelTop>
            <h2>News</h2>
        </PanelTop>
        <PanelBody>{news.map(item => <NewsItem key={item.nid} item={item} />)}</PanelBody>
    </Panel>
);

const News = connect(state => ({
    news: state.data.news
}))(NewsX);

export default News;

const NewsItem = ({ item }) => (
    <div className="cc-news-item">
        <h3 className="cc-news-subject">{item.subject}</h3>
        <div className="cc-news-poster">
            Posted by <PlayerLink pid={item.pid} fname={item.fname} lname={item.lname} norollover /> on {item.long_date}
        </div>
        <div className="cc-news-body" dangerouslySetInnerHTML={{ __html: item.body }} />
    </div>
);



// WEBPACK FOOTER //
// ./src/views/home/News.jsx